package com.milta.feature.importjobs.domain.entity

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * Which AI import a job belongs to. Serialized as the `flow` value of `ImportJobDto`; [pathSegment]
 * is the flow part of the submit and retry routes (`/import-jobs/{pathSegment}[/{id}/retry]`),
 * which keeps the backend's per-flow rate limits.
 */
@Serializable
enum class ImportJobFlow(val pathSegment: String) {
    @SerialName("Pdf") PDF("pdf"),
    @SerialName("Spreadsheet") SPREADSHEET("spreadsheet"),
    @SerialName("OcrDeliveryList") OCR_DELIVERY_LIST("ocr-delivery-list"),
}
